import React, { Component } from 'react';
import { NavLink, Route } from 'react-router-dom';
import IframePage from '../iframePage';
import AppConfig from '../../appConfig';

class Index extends Component {
    active = {
        color: "white"
    };

    render() {
        const taskUrl = AppConfig.env('taskUrl');
        return (
            <div>
                <div className="secondary-navbar">
                    <span><NavLink exact to={AppConfig.baseUrl + 'Projects'} className='nav-link'>PLANNING</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/TaskBoard'} className='nav-link'>TASK BOARD</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/TaskList'} className='nav-link'>TASK LIST</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/WorkLog'} className='nav-link'>WORK LOG</NavLink></span>
                    {/* <span><NavLink to={AppConfig.baseUrl + 'Projects/Planner'} className='nav-link'>PLANNER</NavLink></span> */}

                    <span><NavLink exact to={AppConfig.baseUrl + 'Projects/DBScripts'} className='nav-link'>DB SCRIPTS</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/Versions'} className='nav-link'>VERSIONS</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/ReleaseNotes'} className='nav-link'>RELEASE NOTES</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/Deployment'} className='nav-link'>DEPLOYMENT</NavLink></span>
                    <span><NavLink to={AppConfig.baseUrl + 'Projects/Files'} className='nav-link'>FILES</NavLink></span>
                </div>
                <>
                    <Route path={AppConfig.baseUrl + 'Projects'} exact strict render={() => { return (<IframePage src={taskUrl + 'Planning'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/TaskBoard'} exact strict render={() => { return (<IframePage src={taskUrl + 'Board'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/TaskList'} exact strict render={() => { return (<IframePage src={taskUrl + 'Tasks'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/WorkLog'} exact strict render={() => { return (<IframePage src={taskUrl + 'WorkLog'} />) }} />
                    {/* <Route path={AppConfig.baseUrl + 'Projects/Planner'} exact strict render={() => { return (<IframePage src={taskUrl + 'Planner'} />) }} /> */}
                    <Route path={AppConfig.baseUrl + 'Projects/Files'} exact strict render={() => { return (<IframePage src={taskUrl + 'Files'} />) }} />

                    <Route path={AppConfig.baseUrl + 'Projects/DBScripts'} exact strict render={() => { return (<IframePage src={taskUrl + 'DBScripts'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/Versions'} exact strict render={() => { return (<IframePage src={taskUrl + 'Versions'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/ReleaseNotes'} exact strict render={() => { return (<IframePage src={taskUrl + 'ReleaseNotes'} />) }} />
                    <Route path={AppConfig.baseUrl + 'Projects/Deployment'} exact strict render={() => { return (<IframePage src={taskUrl + 'Deployment'} />) }} />
                </>
            </div>
        );
    }
}

export default Index;
